import { omit } from 'underscore';
import { getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';

export function getBulkDetailConfig(props) {
  const { i18n, scope, siteMap } = props;
  const pathname = getRoutePathById(siteMap, 'bulk-edits');
  const search = scope.stringify(omit(scope.values, 'bulkEditSessionId'));

  return {
    backButtonProps: {
      url: `${pathname}?${search}`,
      buttonText: i18n.getString(_TL_('Back to Bulk edits')),
    },
    breadcrumbsGeneralConfigs: {
      items: [
        {
          key: 'bulkedits',
          text: i18n.getString(_TL_('Bulk edits')),
          onClick: () => {
            scope.history.push({
              pathname,
              search,
            });
          },
          'aria-label': 'Bulk edits',
        }, {
          key: 'details',
          text: i18n.getString(_TL_('Details')),
          'aria-label': 'Details',
          isCurrentItem: true,
        },
      ],
      maxDisplayedItems: 2,
    },
  };
}
